module.exports = __webpack_public_path__ + "img/user_inventory.14a4f071.svg";